import * as actionTypes from './actionTypes';
import axios from 'axios';

import * as ShipConstants from '../../Global/Constants';
import { setUserSession, setUserAuthoritiesSession, getToken, setUserInfoSession, getCurrentProfileId, setProfileAuthoritiesSession, setProfileAuthoritiesSessionEmpty, setCurrentModuleId } from '../../Utils/UserFunctions';
import { parameterizedURLAccessToken } from '../../Utils/CommonFunctions';

// import { browserHistory } from 'react-router'


export const loader = (bool='AUTO') => {
	return {
		type: actionTypes.LOADER,
		bool:bool
	};
}

export const authStart = () => {	
	return {
		type: actionTypes.AUTH_START
	};
}

export const authSucess = (authData) => {
	return {
		type: actionTypes.AUTH_SUCCESS,
		authData: authData
	};
}

export const authFail = (error) => {
	return {
		type: actionTypes.AUTH_FAIL,
		error: error
	};
}

export const authUserAuthorities = (authData,userInfo) => {
	return dispatch => {
		// console.log(userInfo);
		// dispatch(authStart());
		let data = [];		
		const url = `${ShipConstants.API_URL}users/userAuthorities?access_token=${authData.access_token}`;
	    axios.get(url)
	    .then(response => {
			// console.log(response);
			setUserAuthoritiesSession(response.data === '' ? data : response.data);
			//console.log(getCurrentProfileId() + 'getCurrentProfileId')	
			dispatch(authProfileAuthorities(authData.access_token)); // my code 07 - Call API to get Profile access authorities		
			let currModId = '';
			const userDefaultMod = userInfo.user_preference.default_module;		
			response.data.data.forEach((arr,ind) => {
				if(userDefaultMod === arr.module_name) {
					currModId = arr.id;
				}
			})
			console.log(currModId);
			setCurrentModuleId(currModId);
			dispatch(loader(false));
			dispatch(authSucess(authData));    
	    })
	    .catch(err => {
	    	dispatch(loader(false));
	    	if(err.response){
	    		console.log("errror============",err.response);
	    		setUserAuthoritiesSession(data);
	    		dispatch(authSucess(authData));   
	   	 	}
	    })

	}
	
}

export const authProfileAuthorities = (access_token) => {
	return dispatch => {
		const profile_id = getCurrentProfileId();
		setProfileAuthoritiesSessionEmpty()
		let data = [];
		const url = ShipConstants.API_URL+'profiles/'+profile_id+'?access_token='+access_token;
		axios.get(url)
		.then(response => {
			// console.log(response + 'profiles' + profile_id);
			setProfileAuthoritiesSession(response.data === '' ? data : response.data);					
			//dispatch(loader());
			//dispatch(authSucess(authData));    
		})
		.catch(err => {
			dispatch(loader(false));
			if(err.response){
				console.log("errror============",err.response);
				setProfileAuthoritiesSession(data);
				//dispatch(authSucess(authData));   
			}
		})
	}    
}

export const auth = (token, body) => {
	return dispatch => {
		let userinfodata = [];
		dispatch(loader());
		dispatch(authStart());
		const url = ShipConstants.API_URL+'oauth/token';
	    axios.post(url, body, {
		  headers: {
		    'Authorization': `Basic ${token}`
		  }
		})
	    .then(response => {
	    	
			// console.log(response.data.access_token);
			setUserSession(response.data);
			// dispatch(authUserAuthorities(response.data));			
			// dispatch(authSucess(response.data)); //remove after userAuthorities api work
				
			// API get logged in user info by use of Access Token and set session
			const url = ShipConstants.API_URL+'users/info?access_token='+response.data.access_token;
			axios.get(url)
			.then(res => {
				if(res.status===200){
					const userresponse = res.data;
					if(userresponse.code===200){						
						setUserInfoSession(userresponse === '' ? userinfodata : userresponse);

						dispatch(authUserAuthorities(response.data,userresponse.data));	
					}
				}						
			})
			.catch(err => {				
				if(err.res){
					console.log("errror============userinfo",err.res);
					setUserInfoSession(userinfodata);					   
				}
			})
			
			
	    })
	    .catch(err => {
	    	dispatch(loader());
	    	if(err.response){
	    		let errDisp = '';
	    		if(err.response.data.error) {
	    			errDisp = err.response.data.error;
	    		}else {
	    			errDisp = err.response.data.errors;
	    		}
	    		console.log("errror============",errDisp);
	    		dispatch(authFail(errDisp));
	   	 	}else {
	   	 		const errors = ["Connection Refused. Please contact admin..."];
	   	 		console.log("Connction Error============",err);
	   	 		dispatch(authFail(errors));
	   	 	}
	    })

	}
}


export const signUpStart = () => {
	return {
		type: actionTypes.SIGNUP_START
	};
}

export const signUpSucess = (succMsg) => {
	return {
		type: actionTypes.SIGNUP_SUCCESS,
		msg: succMsg
	};
}

export const signUpFail = (error) => {
	return {
		type: actionTypes.SIGNUP_FAIL,
		error: error
	};
}

export const signUpViolation = (error) => {
	return {
		type: actionTypes.SIGNUP_VIOLATIONS,
		error: error
	};
}

export const redirectAutoURL = (url) => {
	//console.log('RedirectURL = '+url);
	//this.props.history.push('/login');
	return {
		type: actionTypes.REDIRECT_URL,
		redirectURL: url
	};
}

export const clearRedirectURL = () => {	
	return {
		type: actionTypes.CLEAR_REDIRECT_URL,
		redirectURL: null
	};
}

export const signUp = (body, locale) => {
	return dispatch => {
		dispatch(loader());
		dispatch(signUpStart());
		const url = ShipConstants.API_URL+'organizations/signup';
	    axios.post(url, JSON.stringify(body), {
		  headers: {
		    'Content-Type': 'application/json'
		  }
		})
	    .then(response => {
	    	dispatch(loader());
	    	if(response.data.code) {
	    		if(response.data.code === 200) {
	    			if(response.data.message) {
	    				console.log('Signup Success---->',response.data);
						dispatch(signUpSucess(response.data.message));
						setTimeout(() => {
							setTimeout(() => dispatch(redirectAutoURL('/login')));
						}, 5000);
	    			}/*else if(response.data.violations){
	    				console.log('Signup Success but faill---->',response.data.violations);
	    				dispatch(signUpViolation(JSON.stringify(response.data.violations)));
	    			}*/
					// dispatch(signUpSucess(response.data.message));
	    		}else if(response.data.code === 400) {
	    			console.log('Signup Success but faill---->',response.data.violations);
    				if(response.data.violations) {
	    				if(response.data.violations.length > 0) {
		    				dispatch(signUpViolation(JSON.stringify(response.data.violations)));	
		    			}else {
		    				dispatch(signUpFail(response.data.message));
		    			}
	    			}else {
	    				dispatch(signUpFail(response.data.message));
	    			}
	    		}else {
	    			console.log('Signup Fail---->',response.data);
	    			dispatch(signUpFail(response.data.message));
	    		}
	    	}
	    })
	    .catch(err => {
	    	dispatch(loader());
	    	if(err.response){
	    		console.log("errror============",err.response.data.errors);
	    		dispatch(signUpFail(err.response.data.errors));
	   	 	}else {
	   	 		const errors = ["Connection Refused. Please contact admin..."];
	   	 		console.log("Connction Error============",err);
	   	 		dispatch(signUpFail(errors));
	   	 	}
	    })

	}
}

export const requestStart = () => {
	return {
		type: actionTypes.REQUEST_START
	};
}

export const requestSuccess = (data) => {
	return {
		type: actionTypes.REQUEST_SUCCESS,
		data: data
	};
}

export const requestFail = (error) => {
	return {
		type: actionTypes.REQUEST_FAIL,
		error: error
	};
}

export const callServer = (url,body) => {
	return dispatch => {
		dispatch(loader());
		dispatch(requestStart());
		const accessToken = getToken();
		let tokenParameter = "";
		if(accessToken) {
			tokenParameter = '?access_token='+getToken();
		}
		console.log("url-------------------",url)
		const apiURL = ShipConstants.API_URL+url+tokenParameter;
	    axios.post(apiURL, JSON.stringify(body), {
		  headers: {
		    'Content-Type': 'application/json'
		  }
		})
	    .then(response => {
	    	dispatch(loader());
	    	if(response.data.code) {
	    		console.log('API Success---->',response.data);
	    		if(response.data.code === 200) {
	    			if(response.data.message) {
	    				console.log('API Success---->',response.data);
	    				dispatch(requestSuccess(response.data.message));
	    			}else if(response.data.violations){
	    				console.log('API Success but faill---->',response.data.violations);
	    				dispatch(requestFail(JSON.stringify(response.data.violations)));
	    			}
	    		}else {
	    			console.log('API Fail---->',response.data);
	    			dispatch(requestFail(response.data.message));
	    		}
	    	}
	    })
	    .catch(err => {
	    	dispatch(loader());
	    	if(err.response){
	    		console.log("errror============",err.response.data.errors);
	    		dispatch(requestFail(err.response.data.errors));
	   	 	}else {
	   	 		const errors = ["Connection Refused. Please contact admin..."];
	   	 		console.log("Connction Error============",err);
	   	 		dispatch(requestFail(errors));
	   	 	}
	    })

	}
}


export const signUpOAuth = (body) => {
	return dispatch => {
		dispatch(loader(true));
		dispatch(signUpStart());
		const url = ShipConstants.API_URL+'organizations/signup';
	    axios.post(url, JSON.stringify(body), {
		  headers: {
		    'Content-Type': 'application/json'
		  }
		})
	    .then(response => {
	    	console.log(response);

	    	const username = ShipConstants.API_AUTORIZATION_USERNAME;
			const password = ShipConstants.API_AUTORIZATION_PASSWORD;
			const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
			
			var requestData = new FormData();
			requestData.set('username', body.email);
			requestData.append('password', body.password); 
			requestData.append('grant_type', ShipConstants.API_GRANT_TYPE);

	    	dispatch(auth(token, requestData));
	    })
	    .catch(err => {
	    	if(err.response){
	    		console.log("errror============",err.response.data.errors);
	    		dispatch(signUpFail(err.response.data.errors));
	   	 	}else {
	   	 		const errors = ["Connection Refused. Please contact admin..."];
	   	 		console.log("Connction Error============",err);
	   	 		dispatch(signUpFail(errors));
	   	 	}
	    })

	}
}

export const assignUpdatedMenu = () => {
	return {
		type: actionTypes.MODULE_CHANGE
		//error: error
	};
}

export const authUserAuthoritiesNew = () => {
	return dispatch => {
		// dispatch(authStart());
		let data = [];		
		const url = 'users/userAuthorities';
	    axios.get(parameterizedURLAccessToken(url))
	    .then(response => {
			// console.log(response);
			setUserAuthoritiesSession(response.data === '' ? data : response.data);
			dispatch(assignUpdatedMenu());
			//console.log(getCurrentProfileId() + 'getCurrentProfileId')
			const accessToken = getToken();	
			dispatch(authProfileAuthorities(accessToken)); // my code 07 - Call API to get Profile access authorities				
			// dispatch(loader());
			// dispatch(authSucess(authData));    
	    })
	    .catch(err => {
	    	dispatch(loader(false));
	    	if(err.response){
	    		console.log("errror============",err.response);
	    		setUserAuthoritiesSession(data);
	    		//dispatch(authSucess(authData));   
	   	 	}
	    })

	}
	
}
